import {healthWorkerImages} from "../../constants/images"

export const workerId = [
    {
      name: "Esther Howard",
      image: healthWorkerImages.estherImage,
      id: "PT-123456",
      detail:"Personal Detail",
      personalDetails: [
        {
          title: "Location:",
          value: "Victoria Island",
          type: "Account Type",
          profession: "Nurse",
          status: "Profession",
          degree: "RedCare HMO",
        },
      ],
    },
  ];

  export const homeCareServicesOptions = [
    'Consultation or treatment by medical practitioner',
    'Medical test or sample collection',
    'Nursing services by a Registered Nurse',
    'Rehabilitation by a Professional Therapist',
    'Drugs dispensing by Pharmacist',
    'Meal preparation',
    'Feeding',
    'Bathing and personal care',
    'Bedside care for minor temporary illness',
    'Medication supervision and dispensing',
    'Assistance with mobility and transfers',
    'Hospital escort',
    'Social outings escort',
    'Errands and Groceries',
    'Laundry',
    'Housekeeping'
  ];

  export const fallRiskRating = ['High Risk', 'Medium Risk', 'Low Risk', 'Very Low Risk'];
  export const PressurSoreRisk = ['No Pressure Sores Identified', 'Pressure Sores Identified', 'High Risk Of Developing Pressure Sores', 'High Risk Of Developing Pressure Sores' ];
  export const riskRatingOptions = ['Both Bowel and Bladder Incontinent','Bowel Incontinent Only', 'Bladder Incontinent',
                             'Fully Continent(Able to Control Both Bowel and Bladder', 'Continent But Require Assistance With Toileting'];
  export const mobilityOptions = ['Fully Independent', 'Uses Walking Aid', 'Wheelchair User', 'Bed Bound'];
  export const shiftPatternOptions = ['4 hours', '8 hours', '12 hours', '24 hours', 'Live-in'];
  export const workPatternOptions = ['Daily', 'Weekly', 'Fortnightly', 'Monthly', 'Indefinite'];
  export const RecommendedWorkPattern = ['Care Giver Live With Patient On Full Time', 'Nights-Caregiver Sleeps Over With Patient',
    'Caregiver Lives With Patient Only on Weekend', 'Caregiver Resumes Every Morning and Closes In The Evening', 'Caregiver Attends To Patient A Number Of Hours In A Day, A Week or A Month'
  ]



  
  